import dayjs from 'dayjs';
import utc from 'dayjs/plugin/utc';
import localizedFormat from 'dayjs/plugin/localizedFormat';
import { DATETIME_FORMAT, DATE_FORMAT } from '../../constants';
import 'dayjs/locale/es';

dayjs.extend(utc);
dayjs.extend(localizedFormat);

class DateFormatter {
  static tryParse(format) {
    const m = /^date(-only)?(-utc)?$/.exec(format);

    return m ? new DateFormatter(!!m[1], !!m[2]) : null;
  }

  constructor(onlyDate, keepAsUTC) {
    this.onlyDate = onlyDate;
    this.keepAsUTC = keepAsUTC;
  }

  apply(value, locale = 'en') {
    if (!value) return '';
    let date = dayjs.utc(value);

    if (!this.keepAsUTC) date = date.local();

    return date.locale(locale).format(this.onlyDate ? DATE_FORMAT : DATETIME_FORMAT);
  }

  parse(value) {
    const m = /date\((.+)\)/.exec(value);

    return m ? m[1] : 0;
  }
}

export default DateFormatter;
